module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Alocar bolsas"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.idBolsa),
      callback: function($$v) {
        _vm.idBolsa = $$v
      },
      expression: "idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtInicio", $$v)
      },
      expression: "bolsa.dtInicio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtFim", $$v)
      },
      expression: "bolsa.dtFim"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "green",
            "disabled": !_vm.idBolsa || !_vm.bolsa.dtInicio || !_vm.bolsa.dtFim,
            "tooltip": "Adicionar uma bolsa a esta ação",
            "disabled-tooltip": "Selecione uma bolsa e informe as datas"
          },
          on: {
            "click": function($event) {
              return _vm.adicionarBolsa(props.item.idProjeto)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d3065c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/alocar-bolsa-tabela.vue
// module id = 386
// module chunks = 0